var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 78,
    viewBox: "0 0 266 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2011_1007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.938 9.13513C140.506 9.13513 131.593 18.2703 131.593 31.6216V59.7297H140.741V31.1531C140.741 22.7207 145.432 17.3333 152.938 17.3333C160.445 17.3333 165.371 22.7207 165.371 31.1531V59.4955H174.284V31.3874C174.519 18.2703 165.605 9.13513 152.938 9.13513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9877 15.4594C37.2963 11.2432 31.4321 8.90088 25.0988 8.90088C11.0247 8.90088 0 20.1441 0 34.6666C0 49.1892 11.0247 60.1982 25.0988 60.1982C31.4321 60.1982 37.2963 57.8558 41.9877 53.6396C41.284 62.5405 34.2469 69.5676 25.0988 69.5676C21.3457 69.5676 18.2963 68.3964 15.4815 66.2883L9.14815 72.6126C13.6049 76.1261 19 78 25.0988 78C39.642 78 50.9012 66.7567 50.9012 52.4684V8.90088H41.9877V15.4594ZM25.5679 51.7657C16.4198 51.7657 9.14815 44.2702 9.14815 34.6666C9.14815 25.063 16.4198 17.5675 25.5679 17.5675C34.716 17.5675 41.9877 25.063 41.9877 34.6666C41.9877 44.2702 34.716 51.7657 25.5679 51.7657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7036 29.982V59.4955H66.6172V29.982C66.6172 22.0181 70.8394 17.3334 77.6419 17.3334C77.8764 17.3334 77.8764 17.3334 78.111 17.0992L70.8394 9.83789C62.8641 12.6487 57.7036 19.91 57.7036 29.982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.235 0H181.321V59.4955H190.235V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.864 18.7388L208.531 12.4144L192.58 31.3874C191.876 32.3243 191.642 33.027 191.642 34.1982C191.642 35.3694 192.111 36.5406 192.814 37.4775L211.345 59.4955H223.074L201.728 34.1982L214.864 18.7388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.766 43.3333L247.235 43.5675L265.062 22.2522C266.235 20.8468 266.938 17.5675 264.358 14.991C260.136 11.009 254.037 8.66663 247.704 8.66663C233.395 8.66663 222.371 19.9099 222.371 34.4324C222.371 48.9549 233.395 60.1982 247.704 60.1982C253.803 60.1982 259.198 58.09 263.655 54.5765L257.556 48.4865C255.21 50.3603 252.161 51.7657 247.938 51.7657C238.79 51.7657 231.753 44.2702 231.753 34.4324C231.753 24.5946 239.025 17.0991 247.938 17.0991C250.988 17.0991 253.803 18.036 255.914 19.4414L241.136 37.009L246.766 43.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.494 8.90088C92.4199 8.90088 81.1606 20.1441 81.1606 34.6666C81.1606 49.1892 92.1853 60.4324 106.494 60.4324C112.358 60.4324 117.988 58.3243 122.445 54.8108L116.346 48.7207C114 50.5946 110.951 52 106.729 52C97.5804 52 90.3088 44.5045 90.3088 34.6666C90.3088 24.8288 97.3458 17.3333 106.729 17.3333C109.778 17.3333 112.593 18.2702 114.704 19.6757L99.6915 37.4775L105.556 43.3333L106.025 43.5676L123.852 22.2522C125.025 20.8468 125.729 17.5675 123.148 14.991C118.926 11.2432 112.827 8.90088 106.494 8.90088Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2011_1007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c1e503ab42d8488f4491181c4dfb6195.svg";
export { ForwardRef as ReactComponent };